// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__JNpKk","backBtn":"styles_backBtn__1I_cD"};